<script>
import Vue from 'vue';
import EmailTemplate from '~/models/EmailTemplate';
import ResourceSelect from '~/components/ResourceSelect/ResourceSelect.vue';

export default Vue.extend({
  extends: ResourceSelect,

  props: {
    getOptionLabel: {
      type: Function,
      required: false,
      default: (resource) => resource?.label,
    },

    query: {
      type: Object,
      required: false,
      default: () => new EmailTemplate(),
    },
  },

  methods: {
    fetch() {
      return this.query.$all();
    },
  },
});
</script>
